<mat-tab-group [mat-stretch-tabs]="false">
  @if (hasCooling()) {
    <mat-tab label="Cooling Conditions">
      <ng-template matTabContent>
        <app-sureflow-loop-condition-detail (deleteUnits)="deleteLoopUnits()" [isCooling]="true" [units]="units()"
          [invalidUnitIds]="invalidUnitIds()"
          [selectedUnitIds]="selectedUnitIds()" [detail]="loopDetail()"
          (addUnit)="addLoopUnit($event)" (editUnits)="editLoopUnits()"
          (copyUnits)="copyLoopUnits()" (addNonSureFlowUnit)="addNonSFUnit($event)"
          (unitSelectionChanged)="selectionChanged($event)"
          (recalculate)="recalculateLoop($event)" (autoSelect)="autoSelectUnits($event)"
          (unitsRearranged)="rearrangeUnits($event)">
        </app-sureflow-loop-condition-detail>
      </ng-template>
    </mat-tab>
  }
  @if (hasHeating()) {
    <mat-tab label="Heating Conditions">
      <ng-template matTabContent>
        <app-sureflow-loop-condition-detail (deleteUnits)="deleteLoopUnits()" [isCooling]="false" [units]="units()"
          [invalidUnitIds]="invalidUnitIds()"
          [selectedUnitIds]="selectedUnitIds()" [detail]="loopDetail()"
          (addUnit)="addLoopUnit($event)" (editUnits)="editLoopUnits()"
          (copyUnits)="copyLoopUnits()" (addNonSureFlowUnit)="addNonSFUnit($event)"
          (unitSelectionChanged)="selectionChanged($event)"
          (recalculate)="recalculateLoop($event)" (autoSelect)="autoSelectUnits($event)"
          (unitsRearranged)="rearrangeUnits($event)">
        </app-sureflow-loop-condition-detail>
      </ng-template>
    </mat-tab>
  }
</mat-tab-group>
